import { ActivityDataTargetSchema } from './activity-data.models.ts'
import { ActivityTypeAndDataSchema } from './utilities.ts'

import { z } from 'zod'

export const ProjectServiceAddedActivityDetailsSchema =
  ActivityTypeAndDataSchema(
    'project_service_added',
    z.object({
      service: ActivityDataTargetSchema,
      project: ActivityDataTargetSchema,
    })
  )
